import React from 'react';
import { CenterSpinner } from '@/components/ats';

interface LoaderProps {
  isLoading: boolean;
}

const Loader: React.FC<LoaderProps> = ({ isLoading }) => {
  return isLoading ? <CenterSpinner h="100%" /> : null;
};

export default Loader;
